import React from 'react';
import styled from '@emotion/styled';
import theme from '../design-system/theme';
import {centeredContent, centeredContentNoPadding, formButton, formInput, modularScale} from '../design-system/utils';
import TymeLink from '../components/link.js';
import FlagEnglish from '../design-system/icons/js/FlagEnglish';
import FlagGerman from '../design-system/icons/js/FlagGerman';
import StyledCopy from "../design-system/typography/copy";
import ParagraphHeading from "../design-system/typography/paragraph-heading";
import Copy from "../design-system/typography/copy";
import Logo from "./logo";
import RoundAppButton from "./round-app-button";
import Heading from "../design-system/typography/heading";
import ReviewContainer from "./review-container";
import StarIcon from "../assets/review/star.svg";

export default class SiteFooter extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            submitNewsletterSuccess: false
        };

        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(e) {
        e.preventDefault();

        let body = new URLSearchParams();
        body.append('l', theme.language);
        body.append('email', e.target.elements.email.value);
        body.append('marketing_consent', 1);

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        };

        let serverURL = 'https://api.tyme-app.com/v1/newsletter';

        if (process.env.NODE_ENV !== `production`) {
            serverURL = 'https://staging.tyme-app.com/v1/newsletter';
        }

        function responseHandler(response) {
            if (response.status === 200) {
                this.setState({
                    submitNewsletterSuccess: true
                });
            }
            return response.json();
        }

        fetch(serverURL, {
            method: 'post',
            body: body,
            headers: headers
        }).then(responseHandler.bind(this));
    }

    render() {
        const {textResources, location} = this.props;
        const {submitNewsletterSuccess} = this.state;

        let languageLink = textResources['language_link'];
        let displayENFlag = languageLink.includes("/en");

        return (
            <StyledSiteFooter>
                <div className="newsletter-content">
                    <div>
                        {
                            submitNewsletterSuccess ?
                                <div>
                                    <ParagraphHeading>{textResources['footer']['newsletter_confirm_title']}</ParagraphHeading>
                                    <StyledCopy
                                        big={true}>{textResources['footer']['newsletter_confirm_info']}</StyledCopy>
                                </div> :
                                <div>
                                    <ParagraphHeading>{textResources['footer']['newsletter_title']}</ParagraphHeading>
                                    <StyledCopy big={true}>{textResources['footer']['newsletter_info']}</StyledCopy>
                                    <form method="POST" onSubmit={this.onSubmit}>
                                        <input type="email" name="email"
                                               placeholder={textResources['footer']['newsletter_placeholder']}
                                               required/>
                                        <input type="submit" value={textResources['footer']['newsletter_button']}/>
                                    </form>
                                </div>
                        }
                    </div>
                </div>

                <div className="footer-content">
                    <div>
                        <div className="footer-section intro">
                            <p className="footer-logo-container">
                                <Logo scale={0.8}/>
                                <div>
                                    <Heading componentType={"h2"}>4.7</Heading>
                                    <img src={StarIcon}/>
                                </div>
                            </p>
                            <StyledCopy componentType={"span"}
                                        dangerouslySetInnerHTML={{__html: textResources['footer']['intro']}}/>
                            <RoundAppButton
                                className="downloadButton"
                                title={textResources['footer']['get_tyme']}
                                linkTarget={'/download/'}
                                color={"#000000"}
                                big={false}
                            />
                        </div>
                        <div className="footer-section">
                            <Heading componentType={"h2"}>{textResources['footer']['section_tyme']}</Heading>
                            <TymeLink className="footer-link" to="/pricing/">{textResources['pricing']}</TymeLink>
                            <TymeLink className="footer-link" to="/blog/">{textResources['blog']}</TymeLink>
                            <TymeLink className="footer-link"
                                      to="/release-notes/">{textResources['release_notes']}</TymeLink>
                            <TymeLink className="footer-link" to="/plugins/">{textResources['plugins']}</TymeLink>
                            <TymeLink className="footer-link"
                                      to="/api-doc/">{textResources['footer']['api_doc']}</TymeLink>
                            <TymeLink className="footer-link" to="/who-we-are/">{textResources['who']}</TymeLink>
                        </div>
                        <div className="footer-section">
                            <Heading componentType={"h2"}>{textResources['footer']['section_topics']}</Heading>
                            <TymeLink className="footer-link"
                                      to="/first-steps/">{textResources['first_steps']}</TymeLink>
                            <TymeLink className="footer-link"
                                      to={textResources['first_steps_team_link']}>{textResources['first_steps_team']}</TymeLink>
                            <TymeLink className="footer-link"
                                      to="/shortcut-gallery/">{textResources['shortcut_gallery']}</TymeLink>
                            <TymeLink className="footer-link"
                                      to="/partner-grandtotal/">{textResources['footer']['partner_grandtotal']}</TymeLink>
                            <TymeLink className="footer-link"
                                      to="/partner-lexware-office/">{textResources['footer']['partner_lexoffice']}</TymeLink>
                            <TymeLink className="footer-link"
                                      to="/partner-sevdesk/">{textResources['footer']['partner_sevdesk']}</TymeLink>
                        </div>
                        <div className="footer-section">
                            <Heading componentType={"h2"}>{textResources['footer']['section_service']}</Heading>
                            <TymeLink className="footer-link" to="/help/">{textResources['help']}</TymeLink>
                            <TymeLink className="footer-link" to="/imprint/">{textResources['imprint']}</TymeLink>
                            <TymeLink className="footer-link" to="/privacy-web/">{textResources['privacy']}</TymeLink>
                            <TymeLink className="footer-link" to="/contact/">{textResources['contact']}</TymeLink>
                        </div>
                    </div>
                    <div>
                        <div className="love">
                            {
                                textResources['footer']['love']
                                    .replace("%@", new Date().getFullYear())
                            }
                        </div>
                        <div className="language-layer">
                            <a href={languageLink}>{textResources['language_text']}</a>&nbsp;
                            {displayENFlag ? <FlagEnglish width="25" height="16"/> :
                                <FlagGerman width="25" height="16"/>}
                        </div>
                    </div>
                </div>
            </StyledSiteFooter>
        );
    }
}

const StyledSiteFooter = styled('div')`
    margin-left: 0;
    margin-right: 0;
    padding-bottom: 20px;
    z-index: 1;
    background-color: #ffffff;

    .footer-content {
        ${centeredContent};
        display: flex;
        flex-direction: column;
        gap: 50px;
    }

    .footer-content > div {
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 20px;
        padding-right: 20px;

        font-size: ${modularScale(-0.75)};

        display: flex;
        flex-direction: column;
        gap: 40px;

        @media (min-width: ${theme.breakpoints.tablet}px) {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            justify-content: space-between;
            padding-left: 0;
            padding-right: 0;
        }
    }

    .footer-section {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        gap: 9px;
    }

    a {
        text-decoration: none;
        color: ${theme.colors.text};
    }

    .footer-link {
        color: ${theme.colors.text};
    }

    .language-layer {
        display: flex;
        align-items: center;
        flex-direction: row;
        gap: 5px;

        a {
            color: ${theme.colors.text};
        }
    }

    .intro {
        font-size: ${modularScale(-1.0)};
        max-width: 230px;
        gap: 0;
    }
    
    .downloadButton {
        margin-top: 20px;
        width: 230px;
    }
    
    .footer-logo-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;

        > div:last-child {
            display: flex;
            flex-direction: row;
            justify-content: left;
            align-items: center;
            gap: 2px;

            > h2 {
                margin: 0;
                padding: 0;
            }
        }
    }

    .love {
        color: #4B4B4B;
        font-size: ${modularScale(-1.0)};
    }

    .newsletter-content {
        background-color: #efefef;
        padding-top: 40px;
        padding-bottom: 70px;
    }

    .newsletter-content > div {
        ${centeredContent};
    }

    .newsletter-content > div > div {
        ${centeredContentNoPadding};

        @media (min-width: ${theme.breakpoints.tablet}px) {
            max-width: 66%;
        }
    }

    .newsletter-content > div > div > form {
        padding-top: 10px;
        display: flex;
        align-items: center;
        gap: 20px;
        flex-direction: column;
        width: 100%;
        margin: 0 auto;

        @media (min-width: ${theme.breakpoints.tablet}px) {
            flex-direction: row;
            width: 100%;
        }
    }

    input[type=email] {
        ${formInput};
        border: 0 none;
        width: 100%;
    }

    input[type=submit] {
        ${formButton};
        background-color: #000000;
        width: 100%;
    }
`;